const apiEndpoint = window.location.origin + '/api/';

export { apiEndpoint };
